module.exports = __webpack_public_path__ + "img/mood_visual_placeholder.57436145.jpeg";